//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goTo from 'vuetify/lib/services/goto'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

import getDirectoriesRandomFiles from '~/pages/sandbox/Helpers/GetDirectoriesRandomFiles'
import getFirstImageDimension from '~/pages/sandbox/Helpers/GetFirstImageDimension'
import getImageFromFile from '~/pages/sandbox/Helpers/GetImageFromFile'
import { artworkMaxWidth, artworkCount } from '~/pages/sandbox/Helpers/Config'
import CheckSupportedBrowser from '~/pages/sandbox/Helpers/CheckSupportedBrowser'
import { stepsSandbox } from '~/utils/tour.steps'

export default {
  name: 'Sandbox',
  data() {
    return {
      dirHandle: null,
      supportedBrowser: null,
      artworks: [],
      error: '',
      artCount: artworkCount,
      dialog: false,
      showWeight: false,
      composition: [],
      tourSteps: [],
      vueTourCallbacks: {
        onSkip: this.tourHide,
        onFinish: this.tourHide,
        onStop: this.tourHide,
        onPreviousStep: this.vueTourPreviousStep,
        onNextStep: this.vueTourNextStep,
      },
      createNewLoading: false,
    }
  },
  computed: {
    errorMessage() {
      return this.error
    },
    userAddress() {
      if (this.$auth.user) return this.$auth.user.wallet

      return null
    },
  },
  mounted() {
    this.supportedBrowser = CheckSupportedBrowser()

    // console.log('-----------------')
    // console.log(stepsSandbox)

    this.tourSteps = stepsSandbox

    // setTimeout(() => {
    //   if (this.$store.state.prefs.vueTourSandbox) {
    //     this.$tours.myTour.start(this.$store.state.prefs.vueTourStepSandbox)
    //   }
    // }, 500)
  },
  methods: {
    async createCollection() {
      if (!this.userAddress) {
        await this.$store.dispatch('addSnackbar', {
          text: `Please Sign in.`,
          type: 'error',
        })
        goTo(0)
        // return
      } else {
        if (this.createNewLoading) return

        this.createNewLoading = true

        try {
          const project = await this.$store.dispatch('models/Project/newFromModel', {
            token: this.$store.state.token
          })

          await this.$router.push({
            path: `/collections/${project.slug}?artwork=1`
          });

        } catch (err) {
          await this.$store.dispatch('addSnackbar', {
            text: `There was an error creating new collection. Please try again later.`,
            type: 'error',
          })
        }
      }
    },
    async chooseFolder() {
      try {
        this.error = ''
        this.dirHandle = await window.showDirectoryPicker()
        this.$store.commit('artwork/SET_DIR_HANDLE', this.dirHandle)
        await this.refresh()
      } catch (e) {}
    },
    async refresh() {
      this.artworks = []

      try {
        for (let i = 0; i < artworkCount; i++) {
          const files = await getDirectoriesRandomFiles(this.dirHandle)

          if (files.length > 0) {
            const dimension = await getFirstImageDimension(files[0])
            const type = files[0].type

            const canvas = document.createElement('canvas')
            canvas.width = artworkMaxWidth
            canvas.height = Math.round(
              dimension.height / (dimension.width / canvas.width)
            )

            const ctx = canvas.getContext('2d')

            const composition = []
            for (const file of files) {
              composition.push({
                parent: this.cleanDirectoryName(file.parent),
                file: this.cleanFileName(file.name),
                height: canvas.height,
              })

              const image = await getImageFromFile(file)
              ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
            }

            this.artworks.push({
              link: canvas.toDataURL(type),
              composition,
            })

            canvas.remove()
          }
        }

        this.$store.commit('artwork/SET_ARTWORK', this.artworks)
      } catch (e) {
        this.error = e.message
      }
    },
    cleanDirectoryName(name) {
      const ar = name.split('_')
      ar.splice(0, 1)
      return ar.join(' ')
    },
    cleanFileName(str) {
      let re
      // remove option num and leading _
      re = /^([0-9]+)_/
      str = str.replace(re, '')
      // remove weight file time (.png from end of string)
      re = /_([0-9]+)\.[a-z]+$/
      str = str.replace(re, '')
      // replace _ & - with spaces, trim outer whitespace
      re = /[_-]+/g
      str = str.replace(re, ' ').trim()

      re = /\.[a-z]+$/
      str = str.replace(re, '')

      // CamelCase the remaining string
      str = this.toTitleCase(str)
      return str
    },
    toTitleCase(str) {
      return str
        .toLowerCase()
        .split(' ')
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1)
        })
        .join(' ')
    },
    makeZip() {
      const zip = new JSZip()
      for (const index in this.artworks) {
        zip.file(
          `artwork${parseInt(index) + 1}.png`,
          this.artworks[index].link.split(';base64,')[1],
          { base64: true }
        )
      }
      zip.generateAsync({ type: 'blob' }).then(function (content) {
        // see FileSaver.js
        saveAs(content, 'example.zip')
      })
    },
    startTour() {
      this.$store.dispatch('setPref', {
        pref: `vueTourSandbox`,
        value: true,
      })
      this.$tours.myTour.start(this.$store.state.prefs.vueTourStepSandbox)
    },
    tourHide() {
      this.$store.dispatch('setPref', {
        pref: `vueTourSandbox`,
        value: false,
      })
    },
    vueTourPreviousStep() {
      this.$store.dispatch('setPref', {
        pref: `vueTourStepSandbox`,
        value: this.$store.state.prefs.vueTourStepSandbox - 1,
      })
    },
    vueTourNextStep() {
      this.$store.dispatch('setPref', {
        pref: `vueTourStepSandbox`,
        value: this.$store.state.prefs.vueTourStepSandbox + 1,
      })
    },
  },
}
